var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { jhaStyles } from '@banno/jha-wc/src/styles/jha-styles.js';
import '@jack-henry/jh-icons/icons-wc/icon-xmark.js';
import '@jack-henry/jh-ui/components/progress/progress.js';
const styles = css `
  :host {
    display: flex;
    height: 100%;
  }

  article {
    padding: var(--jh-platform-drawer-content-padding, 0 24px 16px);
    flex: 2;
    overflow: auto;
  }

  footer {
    padding: var(--jh-platform-drawer-footer-padding, 16px 24px);
  }

  #drawer {
    width: var(--jh-platform-drawer-width);
    height: 100%;
    background: var(--jh-color-container-page);
    border-left: 1px solid var(--jh-color-divider-primary);
  }

  #drawer .content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .loading {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .header {
    padding-left: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  button#close {
    background: transparent;
    width: auto;
    border: none;
    cursor: pointer;
    padding: 16px 24px;
    --jh-icon-color-fill: var(--jh-color-content-primary-enabled);
  }
`;
let JhPlatformDrawer = class JhPlatformDrawer extends LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.loading = false;
    }
    static get styles() {
        return [jhaStyles, styles];
    }
    closeDrawer() {
        this.dispatchEvent(new CustomEvent('close-drawer', {
            bubbles: true,
            composed: true,
        }));
    }
    renderLoading() {
        return html `
      <div class="loading">
        <jh-progress type="circular" size="large" indeterminate></jh-progress>
      </div>
    `;
    }
    renderContent() {
        return html `
      <div class="header">
        <div>
          <slot name="drawer-header"
            >${this.heading ? html `<h3>${this.heading}</h3>` : ''}</slot
          >
        </div>
        <button
          id="close"
          type="button"
          title="close drawer"
          @click=${this.closeDrawer}
        >
          <jh-icon-xmark></jh-icon-xmark>
        </button>
      </div>
      <article>
        <slot></slot>
      </article>
      <footer>
        <slot name="footer"></slot>
      </footer>
    `;
    }
    render() {
        return html `
      <div id="drawer" show-header-divider>
        <div class="content">
          ${this.loading ? this.renderLoading() : this.renderContent()}
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], JhPlatformDrawer.prototype, "heading", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], JhPlatformDrawer.prototype, "loading", void 0);
JhPlatformDrawer = __decorate([
    customElement('jh-platform-drawer')
], JhPlatformDrawer);
export default JhPlatformDrawer;
